export const IMAGE_SHAPE_CLASSES: Record<string, string> = {
  square: "rounded-none",
  rounded: "rounded-lg",
  circle: "rounded-full",
};
